import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import similarProducts from "./data/more_colors_data";
import { Link } from "react-router-dom";
import ResponsivePicture from "../../ResponsivePicture";

const productTypeMap = {
  "Klebefolie Laufmeter / Basic Matt": "matt",
  "Klebefolie Laufmeter / Basic Glänzend": "glossy",
  "Klebefolie Laufmeter / Premium": "premium",
  "Klebefolie Laufmeter / High Performance": "highperformance",
  "Klebefolie Laufmeter / Transparent": "transparent",
  "Klebefolie Laufmeter / Premium Metallic": "metalic",
  "Klebefolie Laufmeter / Musterdruck": "dekor",
  "Klebefolie Laufmeter / Neon": "neon",
  "Klebefolie Laufmeter / Milchglas": "frosted",
};

const MoreColorsTeaser = ({ productType }, context) => {
  // Fetch the language from the Redux store
  const language = useSelector((state) => state.i18nState.lang);

  const type = productTypeMap[productType];
  // Guard clause if no type is found in the mapping
  if (!type) return null;

  const products = similarProducts[type]?.products || [];
  const categoryLink = similarProducts[type]?.category_link;

  return (
    <>
      <p className="h6">{context.t("More colors")}</p>
      {products.map(({ slug, thumb_url, name }) => (
        <Link
          to={`/${language}/i/${slug}/`}
          key={slug}
          className="mr-1 mb-1 d-inline-block"
        >
          <ResponsivePicture
            mediumData={{
              sources: [{ url: thumb_url, type: "image/jpeg" }],
              metadata: { width: 48, height: 48 },
            }}
            altTitle={name || ""}
          />
        </Link>
      ))}
      {categoryLink && (
        <div>
          <Link to={`/${language}${categoryLink}`}>
            {context.t("All colors")}
          </Link>
        </div>
      )}
    </>
  );
};

MoreColorsTeaser.propTypes = {
  productType: PropTypes.string.isRequired,
};

/**  define proptype for the 'translation' function  */
MoreColorsTeaser.contextTypes = {
  t: PropTypes.func,
};

export default MoreColorsTeaser;
